import { useState } from "react";
import { RowsPhotoAlbum } from "react-photo-album";
import "react-photo-album/rows.css";

import Lightbox from "yet-another-react-lightbox";
import Zoom from "yet-another-react-lightbox/plugins/zoom";

import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";

import albums from "./albums.json";

function AlbumGallery() {
  const [lightboxState, setLightboxState] = useState({
    albumIndex: -1,
    photoIndex: -1,
  });

  const openLightbox = (albumIndex, photoIndex) => {
    setLightboxState({ albumIndex, photoIndex });
  };

  const closeLightbox = () => {
    setLightboxState({ albumIndex: -1, photoIndex: -1 });
  };

  return (
    <div>
      {albums.map((album, albumIndex) => (
        <div key={albumIndex}>
          <h2 className='albumName'>{album.title}</h2>
          <RowsPhotoAlbum
            photos={album.photos}
            targetRowHeight={150}
            onClick={({ index }) => openLightbox(albumIndex, index)} />
        </div>
      ))}

      {lightboxState.albumIndex >= 0 && (
        <Lightbox
          index={lightboxState.photoIndex}
          slides={albums[lightboxState.albumIndex].photos}
          open={lightboxState.photoIndex >= 0}
          animation={{ fade: 750, swipe: 0 }}
          plugins={[Zoom]}
          close={closeLightbox}
          render={{ buttonZoom: () => null }}
        />
      )}
    </div>
  );
}

export default AlbumGallery;
